<div
  class="cdx-header__global-bar"
  [ngClass]="isDemoMode ? 'obnoxious-demo-color' : ''"
>
  <div
    class="cdx-header__logo--addin"
    [attr.aria-label]="'Clarivate - ' + productName"
    role="button"
    tabindex="0"
  >

    <svg
        width="30px"
        height="30px"
        viewBox="0 0 48.19 48.19"
        xmlns="http://www.w3.org/2000/svg"
        [attr.alt]="'Clarivate - ' + productName"
        >
        <style type="text/css">
        .st0{fill:#FFFFFF;}
        </style>
        <g>
            <path class="st0" d="M18.21,33.99c0.55,1.47,1.22,2.9,2.02,4.29c0.57,0.99,1.21,1.95,1.89,2.86c6.76-1.66,12.78-5.22,17.44-10.08
                c-1.08-2.53-2.52-4.86-4.25-6.95C31.06,29.22,25.05,32.83,18.21,33.99z"/>
            <path class="st0" d="M22.1,7.06c-1.62,2.17-2.94,4.57-3.89,7.15c6.84,1.15,12.86,4.76,17.11,9.89c1.73-2.09,3.17-4.43,4.25-6.95
                C34.89,12.28,28.87,8.72,22.1,7.06z"/>
            <path class="st0" d="M18.21,33.99c-2.06-5.49-2.36-11.46-0.82-17.24c0.23-0.87,0.51-1.71,0.81-2.54c-1.54-0.26-3.12-0.4-4.73-0.4
                c-1.15,0-2.29,0.07-3.4,0.2c-1.88,6.48-1.95,13.47,0,20.16c1.12,0.13,2.25,0.21,3.41,0.21C15.09,34.38,16.67,34.25,18.21,33.99z"/>
        </g>
    </svg>
    | {{ productName + (isDemoMode ? ' Demo' : '') }}
  </div>
</div>
